import { createStore, applyMiddleware, combineReducers } from 'redux'
import { thunk } from 'redux-thunk'
import userReducer from 'src/store/rootReducer'
import dropdownReducer from './academicReducer'

const rootReducer = combineReducers({
  userDetails: userReducer,
  academicData: dropdownReducer,
})

const store = createStore(rootReducer, applyMiddleware(thunk))

export default store
